import React from "react";
import { humanReadableBytes } from "@sscs/utils";

type DisplaySizeProps = {
  sizeInBytes: number;
  fractionDigits?: number;
};

const DisplaySize = ({
  sizeInBytes,
  fractionDigits = 2,
}: DisplaySizeProps): React.JSX.Element => {
  return <>{humanReadableBytes(sizeInBytes, fractionDigits)}</>;
};

export default DisplaySize;
